import React from "react";
import PropTypes from "prop-types";

export default function Fin({ className, ...delegated }) {
  return (
    <svg
      viewBox="0 0 24 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...delegated}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 10C6.53004 7.71495 3.76805 5.71729 0 0L24 0C12.5506 2.70467 11.5202 4.98295 12 10Z"
        fill="currentColor"
      />
    </svg>
  );
}

Fin.propTypes = {
  className: PropTypes.string,
};
